import React from 'react';
import { Link } from 'react-scroll';
import './Navbar.css';

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="nav-container">
        <div className="nav-right">
          <Link to="about" smooth={true} duration={800} className="nav-link">
            About
          </Link>
          <Link to="work" smooth={true} duration={800} className="nav-link">
            Work
          </Link>
          <Link to="contact" smooth={true} duration={800} className="nav-link">
            Contact
          </Link>
          <a href="/caleydames_CV.pdf" target="_blank" rel="noopener noreferrer" className="nav-link nav-cv-link">
            My CV
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;